const commonAndMisc = {
  errorMessage404: "Alamak! Halaman yang anda cari tidak wujud", // translated 
  errorContentUnavailable:
    "Alamak! Kandungan yang anda cari tidak wujud. Sila hubungi kami tentang masalah ini.", // translated 
  backToHome: "Kembali ke Rumah", // translated 
  information: "Maklumat", // translated 
  additionalInformation: "Maklumat Tambahan", // translated 
  destinationPlaceholder: "Ke mana awak pergi?", // translated 
  aboutUs: "Tentang Kami", // translated 
  pleaseWait: "Sila tunggu...", // translated 
  featuredHotels: "Hotel Pilihan", // translated 
  topPackages: "Pakej Terbaik", // translated 
  topTours: "Lawatan Teratas", // translated 
  traveller: "Pengembara", // translated 
  reviews: "Ulasan", // translated 
  home: "Laman Utama", // translated 
  packages: "Pakej", // translated 
  experiences: "Pengalaman", // translated 
  close: "Tutup", // translated 
  loadingMessage: "Sila tunggu sementara kami mencari harga terbaik yang tersedia", // translated 
  loadingMessageTheHotelCo:
    "Sila tunggu sementara kami mencari harga terbaik yang tersedia", // translated 
  loadingMessageSearchStrip:
    "Sila tunggu sementara kami mencari harga terbaik yang tersedia...", // translated 
  topCountriesToVisit: "Negara-negara Terbaik untuk Dilawati", // translated 
  profile: "Profil", // translated 
  reservations: "Tempahan", // translated 
  myBookings: "Tempahan Saya", // translated 
  address: "Alamat", // translated 
  firstName: "Nama Pertama", // translated 
  lastName: "Nama Akhir", // translated 
  email: "E-mel", // translated 
  login: "Log masuk", // translated 
  logout: "Log keluar", // translated 
  myProfile: "Profil Saya", // translated 
  myAccount: "Akaun Saya", // translated 
  myPoints: "Mata Saya", // translated 
  myQuotations: "Sebut Harga Saya", // translated 
  myChatRooms: "Sembang Saya", // translated 
  chatRoomsListEmpty: "Anda tiada bilik sembang untuk akaun ini.", // translated 
  chatRoomsOpen: "Buka", // translated 
  chatRoomsLastActivity: "Aktiviti terakhir", // translated 
  chatRoomsUnread: "Belum dibaca", // translated 
  chatRoomsBadgeQuotation: "Sebut Harga", // translated 
  chatRoomsBadgeTripOffer: "Tawaran perjalanan", // translated 
  chatRoomsOpenQuotationAria: "Buka sembang sebut harga: {{name}}", // translated 
  chatRoomsOpenTripOfferAria: "Sembang tawaran perjalanan terbuka: {{name}}", // translated 
  chatRoomsOpenGenericAria: "Buka sembang: {{name}}", // translated 
  quotationChatInvalidLink:
    "Pautan sembang tidak sah. Buka sembang daripada profil atau senarai sebut harga anda, atau gunakan betul-betul salah satu room_code atau room_uid.", // translated 
  quotationChatNoTripDetails: "Butiran perjalanan tidak tersedia untuk sembang ini.", // translated 
  chat: "Sembang", // translated 
  verified: "Disahkan", // translated 
  unverified: "Tidak disahkan", // translated 
  selectLanguage: "Pilih bahasa", // translated 
  selectCurrency: "Pilih mata wang", // translated 
  upgrade: "Naik taraf", // translated 
  membership: "Keahlian", // translated 
  travelTrust: "Amanah Perjalanan", // translated 
  signInUp: "Daftar Masuk/Daftar Masuk", // translated 
  worldwideHotelsAndResortsAtAmazingWholesaleRates:
    "hotel dan resort di seluruh dunia pada kadar borong yang menakjubkan", // translated 
  dashboard: "Papan Pemuka", // translated 
  pricing: "Penentuan harga", // translated 
  refundable: "Boleh dikembalikan", // translated 
  cars: "Kereta", // translated 
  cruises: "Pelayaran", // translated 
  view: "Lihat", // translated 
  price: "Harga", // translated 
  totalPrice: "Jumlah harga", // translated 
  filterRoomName: "Nama bilik penapis", // translated 
  get: "Dapatkan", // translated 
  guestInformationValidation: "Pengesahan Maklumat Tetamu", // translated 
  reservation: "Tempahan", // translated 
  checkIn: "Daftar Masuk", // translated 
  checkOut: "Daftar Keluar", // translated 
  paymentInitiattionErroeMessage:
    "Kami tidak dapat memulakan proses pembayaran anda. Kami memohon maaf atas kesulitan ini.", // translated 
  warning: "Amaran", // translated 
  couldNotFindPriceForDateWarning:
    "Kami tidak dapat menemui harga untuk tarikh ini. Sila cuba lagi untuk tarikh yang berbeza", // translated 
  searchFormValidationError: "Ralat Pengesahan Borang Carian", // translated 
  pleaseSelectValidDateFirst: "Sila pilih tarikh yang sah terlebih dahulu", // translated 
  searchError: "Ralat Carian", // translated 
  priceSearchInitiationError:
    "Kami tidak dapat memulakan proses carian harga. Sila cuba lagi nanti. Kami memohon maaf atas kesulitan ini.", // translated 
  searchWarning: "Amaran Carian", // translated 
  couldNotFindPriceAndOrAvailability:
    "Kami tidak dapat menemui harga dan/atau ketersediaan untuk permintaan anda. Kami memohon maaf atas kesulitan ini.", // translated 
  joinNow: "Sertai Sekarang", // translated 
  signIn: "Daftar Masuk", // translated 
  searchNow: "Cari sekarang", // translated 
  bookingFailed: "Tempahan gagal", // translated 
  sorryForTheInconvenience: "Kami memohon maaf atas kesulitan ini", // translated 
  contactUsToAssistWithYourBooking:
    "Sila hubungi kami untuk membantu tempahan anda. Kami memohon maaf atas kesulitan ini.", // translated 
  paymentFailedTryAgain: "Pembayaran gagal. Sila cuba lagi", // translated 
  quickLinks: "Pautan Pantas", // translated 
  tours: "Lawatan", // translated 
  termsAndConditions: "Terma dan Syarat", // translated 
  pleaseWaitWhileInitiatingPayment:
    "Sila tunggu sementara kami memulakan proses pembayaran anda", // translated 
  back: "Kembali", // translated 
  nextStep: "Langkah Seterusnya", // translated 
  book: "Buku", // translated 
  checkout: "Daftar keluar", // translated 
  specifyPickUpPoint: "Nyatakan tempat pengambilan pilihan anda", // translated 
  pickupPoint: "Tempat Pengambilan", // translated 
  optional: "pilihan", // translated 
  provideImportantInfoForYourTravel:
    "Beritahu kami sebarang maklumat penting semasa perjalanan anda", // translated 
  remarks: "Catatan", // translated 
  travellerInformation: "Maklumat Pengembara", // translated 
  bookingRemarks: "Catatan Tempahan", // translated 
  bookingOverview: "Gambaran Keseluruhan Tempahan", // translated 
  paymentFailed: "Pembayaran Gagal", // translated 
  paymentSuccess: "Kejayaan Pembayaran", // translated 
  at: "Pada", // At date // translated 
  on: "Hidup", // on date // translated 
  person: "orang", // translated 
  cancellationPolicy: "Polisi Pembatalan", // translated 
  From: "Dari", // translated 
  to: "Kepada", // translated 
  cancellationIs: "pembatalan adalah", // translated 
  pickup: "Pengambilan", // translated 
  flights: "Penerbangan", // translated 
  Accommodation: "Penginapan", // translated 
  payAndBook: "Bayar & Tempah", // translated 
  onRequest: "Atas permintaan", // translated 
  weAreFindingTheBestAvailableServices:
    "Kami sedang mencari perkhidmatan terbaik yang tersedia", // translated 
  withTheBestAvailablePrices: "dengan harga terbaik yang tersedia", // translated 
  inRealTime: "dalam masa nyata", // translated 
  seconds: "saat", // translated 
  thisProcessCanTakeUpToOneMinute: "Proses ini boleh mengambil masa sehingga 1 minit", // translated 
  pleaseDoNotRefreshThisPage: "Tolong jangan muat semula halaman ini", // translated 
  wellItSeemsItCanTakeBitLonger: "Nampaknya... ia boleh mengambil masa yang lebih lama sedikit", // translated 
  yourBrowserDoesNotSupportTheVideoTag:
    "Pelayar anda tidak menyokong teg video", // translated 
  bookingSuccess: "Kejayaan tempahan", // translated 
  bookingReference: "Rujukan Tempahan", // translated 
  referenceCopied: "Rujukan disalin", // translated 
  shortlyYouReceiveEmailContainingInformationForYourReservation:
    "Tidak lama lagi, anda akan menerima e-mel yang mengandungi semua maklumat yang diperlukan untuk tempahan anda", // translated 
  viewMore: "Lihat lebih banyak lagi", // translated 
  readMore: "Baca lebih lanjut", // translated 
  customerSupport: "Sokongan Pelanggan", // translated 
  socialMedia: "Media Sosial", // translated 
  hours: "jam", // translated 
  hour: "jam", // translated 
  minutes: "minit", // translated 
  minute: "minit", // translated 
  memberId: "ID Ahli", // translated 
  star: "Bintang", // translated 
  stars: "Bintang", // translated 
  proceed: "Teruskan", // translated 
  clearAllFilters: "Kosongkan semua penapis", // translated 
  clearYourFilters: "Sila kosongkan pilihan penapis anda untuk melihat hasil carian", // translated 
  noOptionsForSelectedFilters: "Tiada pilihan yang tersedia untuk memadankan penapis anda", // translated 
  privacyPolicy: "Dasar Privasi", // translated 
  security: "Keselamatan", // translated 
  nearby: "Berdekatan", // translated 
  distanceFromSelection: "Jarak dari pilihan", // translated 
  km: "kilometer", // translated 
  restaurants: "Restoran", // translated 
  active: "Aktif", // translated 
  visitSite: "Lawati laman web", // translated 
  score: "Skor", // translated 
  applicationAvailable: "aplikasi tersedia", // translated 
  sendUsEmail: "Hantarkan E-mel kepada kami", // translated 
  sendUsYourRequest: "Hantarkan permintaan anda kepada kami", // translated 
  notAvailable: "Tidak Tersedia", // translated 
  found: "Dijumpai", // translated 
  progressAt: "Kemajuan di", // translated 
  currency: "Mata wang", // translated 
  sendUsRequest: "Hantarkan permintaan anda kepada kami", // translated 
  noReservationsForThisProduct: "Tiada tempahan untuk produk ini", // translated 
  noBookingsForThisProduct: "Tiada tempahan untuk produk ini", // translated 
  noReservationsOfThisProduct: "Tiada tempahan untuk jenis produk ini", // translated 
  actions: "Tindakan", // translated 
  save: "Simpan", // translated 
  confirmed: "Disahkan", // translated 
  cancelled: "Dibatalkan", // translated 
  pending: "Belum selesai", // translated 
  notConfirmed: "Tidak Disahkan", // translated 
  status: "Status", // translated 
  reference: "Rujukan", // translated 
  leadGuest: "Tetamu Utama", // translated 
  sendVoucherEmail: "Hantar E-mel Baucar", // translated 
  sendCancellationEmail: "Hantar E-mel Pembatalan", // translated 
  downloadVoucher: "Muat Turun Baucar", // translated 
  emailHasBeenSent: "E-mel berjaya dihantar", // translated 
  emailNotSentTryAgain: "E-mel tidak dihantar! Sila cuba lagi", // translated 
  titleIsRequired: "Tajuk diperlukan", // translated 
  genderIsRequired: "Jantina diperlukan", // translated 
  firstNameMustContainAlphabetic:
    "Nama pertama mesti mengandungi aksara abjad sahaja", // translated 
  firstNameIsRequired: "Nama pertama diperlukan", // translated 
  lastNameIsRequired: "Nama keluarga diperlukan", // translated 
  lastNameMustContainAlphabetic:
    "Nama keluarga mesti mengandungi aksara abjad sahaja", // translated 
  phoneNumberInTheFormat: "Nombor telefon mestilah dalam format tanpa jarak", // translated 
  phoneNumberIsRequired: "Nombor telefon diperlukan", // translated 
  emailIsRequired: "E-mel diperlukan", // translated 
  invalidEmail: "E-mel tidak sah", // translated 
  addressIsRequired: "Alamat diperlukan", // translated 
  cityIsRequired: "Bandar diperlukan", // translated 
  postalCodeIsRequired: "Poskod diperlukan", // translated 
  countryIsRequired: "Negara diperlukan", // translated 
  yourReservationIsInProgress: "Tempahan anda sedang dijalankan", // translated 
  yourReservationHasBeenRegistered: "Tempahan anda telah didaftarkan", // translated 
  clickHere: "Klik di sini", // translated 
  iHaveReadAgreeWithAbove: "Saya telah membaca dan bersetuju dengan perkara di atas", // translated 
  pleaseCheckTheBox:
    "Sila tandakan kotak di bahagian bawah untuk menunjukkan bahawa anda telah membaca dan bersetuju dengan maklumat yang diberikan sebelum meneruskan ke langkah seterusnya.", // translated 
  pleaseAcceptProperty:
    "Sila tandakan kotak di bahagian atas untuk menunjukkan bahawa hartanah yang sedang ditempah adalah yang anda perlukan.", // translated 
  ourContactNumbersAre: "Nombor telefon kami ialah", // translated 
  operationalHours: "Waktu Operasi", // translated 
  monday: "Isnin", // translated 
  tuesday: "Selasa", // translated 
  wednesday: "Rabu", // translated 
  thursday: "Khamis", // translated 
  friday: "Jumaat", // translated 
  saturday: "Sabtu", // translated 
  sunday: "Ahad", // translated 
  monday_to_friday: "Isnin hingga Jumaat", // translated 
  closed: "Ditutup", // translated 
  topUpPoints: "Mata Tambah Nilai", // translated 
  gender: "Jantina", // translated 
  nationality: "Kewarganegaraan", // translated 
  amountIn: "Jumlah Masuk", // translated 
  amountOut: "Jumlah Keluar", // translated 
  maintenanceTitle: "Laman web dalam penyelenggaraan", // translated 
  maintenanceDescription:
    "Kami sedang menjalankan penyelenggaraan berjadual. Sila semak semula tidak lama lagi.", // translated 
  maintenanceCountdownLabel: "Anggaran masa yang tinggal", // translated 
  maintenanceLogoAlt: "Logo laman web", // translated 
  maintenanceDays: "Hari", // translated 
  maintenanceHours: "Jam", // translated 
  maintenanceMinutes: "Minit", // translated 
  maintenanceSeconds: "Saat", // translated 
  maintenanceStatusBadge: "Penyelenggaraan berjadual", // translated 
  maintenanceRefresh: "Muat semula halaman", // translated 
  maintenanceExpired:
    "Penyelenggaraan akan siap tidak lama lagi. Sila muat semula halaman.", // translated 
};







export default commonAndMisc;
